module.exports = __webpack_public_path__ + "img/fan_close2.92ccc32d.png";